import { render } from "./XiaofeiData.vue?vue&type=template&id=61d944c8&scoped=true"
import script from "./XiaofeiData.vue?vue&type=script&lang=js"
export * from "./XiaofeiData.vue?vue&type=script&lang=js"

import "./XiaofeiData.vue?vue&type=style&index=0&id=61d944c8&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d944c8"]])

export default __exports__